import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TestSurveyService} from "./test-survey.service";
import {SurveyViewerService} from "../../../app/modules/survey/survey-viewer/services/survey-viewer.service";
import {Observable} from "rxjs";
import {Survey} from "../../../app/models/Survey";
import {MatTabsModule} from "@angular/material/tabs";
import {MatIconModule} from "@angular/material/icon";
import {TestSurveyExtComponent} from "./test-survey-ext/test-survey-ext.component";
import {TestSurveyQuestionsComponent} from "./test-survey-questions/test-survey-questions.component";
@Component({
    selector: 'app-test-survey',
    standalone: true,
    imports: [CommonModule, MatTabsModule, MatIconModule, TestSurveyExtComponent, TestSurveyQuestionsComponent],
    templateUrl: './test-survey.component.html',
    styleUrls: ['./test-survey.component.scss']
})
export class TestSurveyComponent implements OnInit {

  survey$: Observable<Survey>= this.surveyViewerService.activeSurvey$;

  constructor(
    public testSurveyService: TestSurveyService,
    public surveyViewerService:SurveyViewerService,
  ) { }

  ngOnInit(): void {
  }

}
